// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#ff7171","root":"Form_root__2osY7","control":"Form_control__22otq","actionsButton":"Form_actionsButton__3Ihqp","error":"Form_error__34nSh"};